import React, { useEffect, useReducer } from 'react'
import { Link } from 'react-router-dom'
import { ACTION_TYPES, Products, ProductReducer } from '../../reducer'

function ProductCard() {
    const [state, dispatch] = useReducer(ProductReducer, Products)

    useEffect(() => {
        const fecthData = async () => {
            dispatch({type: ACTION_TYPES.FETCH_START})
            try {
                const response = await fetch('https://6cbl05gmqj.execute-api.us-east-1.amazonaws.com/api/v1/products')
                if (!response.ok)
                    throw new Error(`Error: ${response.statusText}`)
                const data = await response.json()
                dispatch({type:ACTION_TYPES.FETCH_SUCCESS, payload:data.response})
            }catch(err){

            }
        }
        fecthData()
    },[])
  return (
    <>
        { <div className="grid-products pb-6">
            <div className="columns is-multiline grid-products-inner">
                {state.data?.map((product) => (
                    <div className="column is-one-third-tablet is-one-quarter-desktop is-one-fifth-fullhd">
                        <div className="grid-product">
                            <div className="grid-product-price">
                                <span> {product.price}</span>
                            </div>
                            <div class="grid-product-rating">
                                <i className="fas fa-star highlighted"></i>
                                <i className="fas fa-star highlighted"></i>
                                <i className="fas fa-star highlighted"></i>
                                <i className="fas fa-star highlighted"></i>
                                <i className="fas fa-star highlighted"></i>
                            </div>
                            <div className="grid-product-image">
                                <img src={product.featured} data-demo-src="https://bulkit.cssninja.io/assets/img/demo/products/polish.png" alt="" />
                            </div>
                            <a className="grid-product-info">
                                <h4>{product.category}</h4>
                                <h3>{product.name}</h3>
                                <p dangerouslySetInnerHTML={{__html:product.description.length > 130 ? product.description.slice(0, 130) + '...': product.description}}></p>
                            </a>
                            <div className="buttons">
                                <a className="button is-fullwidth" href={"/product/"+product.slug}>View Details</a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>}
    </> 
  )
}

export default ProductCard
